import { RetrieveBoothSpaceOrganizerResponse } from 'types/swagger'

export interface ItemData {
    id: number
}

export interface DocumentData extends ItemData {
    name: string
    order: number
    url: string
    support_translate?: boolean
    is_native?: boolean
}

export interface VideoData extends ItemData {
    name?: string
    order: number
    url?: string
    embedded_url?: string
}

export interface BoothConfigModal {
    close(): void
    data?: DocumentData | VideoData
}

export interface BoothConfigListItem {
    data?: DocumentData | VideoData
    onButtonDeleteClick(id: number): void
    onButtonEditClick(id: number): void
    showTranslatedIndicator?: boolean
}

export enum EditorMode {
    preview = 'preview',
    write = 'write',
}

export enum VideoType {
    link = 'link',
    upload = 'upload',
}

export type Booth = RetrieveBoothSpaceOrganizerResponse
